import React from 'react'
import { connect } from 'react-redux'

import { generateStateKey } from '../../../../utilities/generateStateKey'

import { loadClips, deleteClips, putClips } from '../../../../store/Settings/actions/components/Clips'
import { openModal, closeModal } from '../../../../store/Modal/actions'

import SettingsClips from './Clips'
import { deleteTimeOutClipsFromPrograms } from '../../../../utilities/deleteTimeOutPrograms'


const SettingsClipsContainer = props => (
    <SettingsClips
        clips={props.clips}
        className={props.className}
        indentIds={props.indentIds}
        objectIds={props.objectIds}
        objects={props.objects}
        loadClips={props.loadClips}
        putClips={props.putClips}
        schedule={props.schedule}
        deleteClips={props.deleteClips}
        openModal={props.openModal}
        closeModal={props.closeModal}
        toggleOpened={props.toggleOpened}
        hideEnded={props.hideEnded}
        tracksRef={props.tracksRef}

    />
)

const stateToProps = (state, props) => ({
    clips: [],
    // getClips(state.objects.trackObjects, state.settings.schedule, props.indentIds, props.objectIds),
    schedule: getClips(state.settings.schedule, state.tracks.hideEnded),
    objects: state.objects.allObjectsAssociated,
    hideEnded: state.tracks.hideEnded,
    tracksRef: state.tracks.tracksRef

})

const actionsToProps = {
    loadClips, deleteClips, openModal, closeModal, putClips
}

export default connect(stateToProps, actionsToProps)(SettingsClipsContainer)

function getClips(objectsClips, hideEnded) {


    const objectsSorted = Object.values(objectsClips).map(c => {

        c.object.sortName = c.object.alias ? c.object.alias : `${c.object.name} ${c.object.address || ''}`
        return c
    });

    const sortByFullname = (a, b) => a.object.sortName < b.object.sortName ? -1 : 1
    const arr1 = objectsSorted.filter(obj => obj.object.msstatus_id === null).sort(sortByFullname);
    const arr2 = objectsSorted.filter(obj => obj.object.msstatus_id !== null).sort((a, b) => {
        return (a.msstatus_id < b.msstatus_id) ? -1 : (a.object.msstatus_id === b.object.msstatus_id ? (a.object.sortName < b.object.sortName ? -1 : 1) : 1)
    });
    let clips = [...arr1, ...arr2];

    if (hideEnded) {
        console.log({ hideEnded });

        clips = clips.map(clips => ({
            ...clips,
            schedule: deleteTimeOutClipsFromPrograms(clips.schedule)
        }))
    }


    return [...arr1, ...arr2]

}